var FetchStatus = /* @__PURE__ */ ((FetchStatus2) => {
  FetchStatus2["success"] = "success";
  FetchStatus2["failed"] = "failed";
  FetchStatus2["loading"] = "loading";
  return FetchStatus2;
})(FetchStatus || {});
var EScrollDirection = /* @__PURE__ */ ((EScrollDirection2) => {
  EScrollDirection2["prev"] = "prev";
  EScrollDirection2["next"] = "next";
  return EScrollDirection2;
})(EScrollDirection || {});
var EVerticalScrollDirection = /* @__PURE__ */ ((EVerticalScrollDirection2) => {
  EVerticalScrollDirection2["forward"] = "next";
  EVerticalScrollDirection2["backward"] = "prev";
  return EVerticalScrollDirection2;
})(EVerticalScrollDirection || {});
export {
  EScrollDirection,
  EVerticalScrollDirection,
  FetchStatus
};
